import { ActionType } from "../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../react-core/Flux/BaseStore";
import { PensionSubAccountSettings } from "../../../Wrap/Models/Domains/SubAccount/PensionSubAccountSettings";
import { PensionSubAccountSettingsDispatcher, FluxResponse } from "./Variable";
export interface PensionSubAccountSettingsState {
    isLoading?: boolean;
    actionType: ActionType;
    pensionSubAccountSettings?: PensionSubAccountSettings;
}
export class PensionSubAccountSettingsStoreStatic extends BaseStore<PensionSubAccountSettingsState> {
    constructor() {
        super();
        this.subscribeToDispatcher(PensionSubAccountSettingsDispatcher, (actionData) => this.onPensionSubAccountSettingsStoreResponse(actionData));
    }

    onPensionSubAccountSettingsStoreResponse(actionData: FluxResponse): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ pensionSubAccountSettings: actionData.payload, actionType: ActionType.Success, isLoading: false });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error, isLoading: false });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType, isLoading: true });
                break;
        }
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getPensionSubAccountSettings() {
        return this.getState().pensionSubAccountSettings;
    }

    protected getDefaultState(): PensionSubAccountSettingsState {
        return { 
            actionType: ActionType.Loading,
            isLoading: false,
            pensionSubAccountSettings: {}
        };
    }
}
